export class LevelModel {
    constructor(
        public LEVEL_NAME: string,
        public APPROVAL_LEVEL_DESCRIPTION?: string,
        public APPROVAL_LEVEL_ID_?:string,
        public LEVEL_ID?: string,
        public ILO?: string,
        public ISTD?: string,
        public SNE?: string,
        public EXECUTOR_ID?: string,
        public MIN_NUMBER_OF_APPROVALS?: string,
        public AMOUNT_SKIP?: string
    ){}
}
